import Voting, { STATUS_RESULT_ANNOUNCED } from './base';
import config from 'config';

export default class MatchResultVoting extends Voting {
  static path = `${config.backOfficeBasePath}/votings/match_result`;

  static validateConstraints = Object.assign({}, Voting.validateConstraints, {

  });

  _getModel() {
    return MatchResultVoting;
  }

  get _createUrl() {
    return `${config.backOfficeBasePath}/events/:eventId/votings/match_result`
      .replace(':eventId', this.eventId);
  }

  async announceResult({first_score, second_score}): Promise<boolean> {
    try {
      await this._networkLayer.patchJSON(
        this._prepareUrl(this.id) + '/results',
        {
          first_score,
          second_score
        }
      );

      this.status = STATUS_RESULT_ANNOUNCED;
      return true;
    }

    catch (e) {
      /* eslint no-console: 0 */
      console.error(e);
      return false;
    }
  }

}



// WEBPACK FOOTER //
// ./src/api/voting/matchResult.ts